import ProductMasterApiUrls from 'src/apiUrls/ProductMasterApiUrls'
import FormProperties from './FormProperties'
import { Box, Card, CardActions, CardContent, Divider } from '@material-ui/core'
import React from 'react'
import { components } from 'cng-web-lib'
import { useParams, generatePath } from 'react-router-dom'
import pathMap from '../../paths/pathMap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const {
  button: { CngButton },
  form: { CngViewForm }
} = components

function ViewPage({ history, showNotification }) {
  const { id } = useParams()

  return (
    <Card>
      <CardContent>
        <CngViewForm
          fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
          showNotification={showNotification}
          renderBodySection={(labelMap, shouldHideMap, shouldDisableMap) => (
            <FormProperties.Fields
              disabled
              isView
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
            />
          )}
          formikProps={FormProperties.formikProps}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
          fetch={{
            id: id,
            url: ProductMasterApiUrls.GET
          }}
        />
      </CardContent>
      <Divider />
      <CardActions style={{ padding: 16, justifyContent: 'space-between' }}>
        <CngButton
          color='secondary'
          onClick={() => history.push(pathMap.PRODUCT_MASTER_LIST_VIEW)}
        >
          Back to product master list
        </CngButton>
        <Box display='flex' style={{ gap: 16 }}>
          <CngButton
            color='primary'
            startIcon={<FontAwesomeIcon icon={['fal', 'pen']} size='sm' />}
            onClick={() => history.push(
              generatePath(pathMap.PRODUCT_MASTER_EDIT_VIEW, { id })
            )}
          >
            Edit
          </CngButton>
        </Box>
      </CardActions>
    </Card>
  )
}

export default ViewPage
